import config from "config/config";

export const STEPS = [
  "terms_and_conditions_step",
  "submission_disclosure_step",
  "move_in_date",
  "personal_details",
  "dependents",
  "emergency_contacts",
  "pets",
  "vehicles",
  "military_first_responder_teacher",
  "lead_source",
  "additional_questions",
  "address",
  "ssn",
  "identity_documents",
  "identity_address",
  "income_verification",
  "combined_income",
  "income_documents",
  "lender_selection",
  "loan_details",
  "home_details",
  "business_state",
  "home_intended_use",
  "demographics",
  "employment_history",
  "assets",
  "address_history",
  "declarations",
  "consents",
  "checkout"
];

export const StepNames = {
  move_in_date: "Move in date",
  personal_details: "Personal details",
  dependents: "Dependents",
  emergency_contacts: "Emergency contacts",
  pets: "Pets",
  vehicles: "Vehicles",
  military_first_responder_teacher: "Military, First Responder, Teacher",
  lead_source: "Lead source",
  address: "Housing history",
  income_verification: "Income verification",
  combined_income: "Combined income",
  submission_disclosure_step: "Submission disclosure",
  checkout: "Checkout",
  additional_questions: "Additional questions",
  identity_documents: "Identity documents",
  identity_address: "Identity address",
  terms_and_conditions_step: "Terms and Conditions",
  income_documents: "Income documents",
  ssn: "Identity information",
  lender_selection: "Lender selection",
  loan_details: "Loan details",
  home_details: "Home details",
  business_state: "Business state",
  home_intended_use: "Home intended use",
  demographics: "Demographics",
  employment_history: "Employment history",
  assets: "Assets",
  address_history: "Address history",
  declarations: "Declarations",
  consents: "Lender consents"
};

export const AX_ORIGIN = config.axOrigin;

export enum SubmissionDisclosureSubStep {
  SelectMethod = "select_method",
  ReviewAndSendEmail = "review_and_send_email",
  SignOnBehalf = "sign_on_behalf",
  EmailSent = "email_sent",
  ReviewAndSign = "review_and_sign",
  Signed = "signed"
}

export enum CombinedIncomeSubStep {
  IncomeStatus = "income_status",
  NoIncomeReason = "no_income_reason",
  SelectIncomeType = "select_income_type",
  CompanyDetails = "company_details",
  OtherIncomeDetails = "other_income_details",
  SupervisorDetails = "supervisor_details",
  PreTaxIncome = "pre_tax_income",
  SelectDocumentType = "select_document_type",
  DocumentUpload = "document_upload",
  AddAnotherIncome = "add_another_income",
  HousingAssistance = "housing_assistance",
  Completed = "completed"
}
